import axiosInstance from "@/lib/axiosInterceptor";
import { getTokenValue } from "./jwtDecode";
import { parseUserAgent } from "./uaInfoParser";

const fetchIp = async () => {
    const res = await axiosInstance.get<{ ip: string }>(`${process.env.NEXT_PUBLIC_BE_URL}/get-ip`);
    return res.data.ip;
};

export function isZohoDeskAvailable() {
    return typeof window !== "undefined" && window.ZohoDeskAsap && typeof window.ZohoDeskAsap !== "undefined";
}

function getFormKey() {
    return `${process.env.NEXT_PUBLIC_ZOHO_DESK_DEPARTMENT_ID}&&&${process.env.NEXT_PUBLIC_ZOHO_DESK_LAYOUT_ID}`;
}

async function prefillZohoDeskForm() {
    const formKey = getFormKey();
    if (!formKey) {
        console.error("Failed to initiate Zoho Desk: Missing department or layout ID.");
        return;
    }

    const ip = await fetchIp();
    const site = window.location.origin || "https://imageresizer.com";
    const user = getTokenValue();

    const uaInfo = await parseUserAgent(navigator.userAgent);
    const browser = uaInfo.browser;
    const os = uaInfo.os;

    const prefillData = {
        cf_user_id: { defaultValue: user?.sub || "", isHidden: true },
        cf_single_line_1: { defaultValue: ip, isHidden: true },
        cf_page: { defaultValue: window.location.href, isHidden: true },
        cf_url: { defaultValue: site, isHidden: true },
        cf_browser: { defaultValue: browser, isHidden: true },
        cf_operating_system: { defaultValue: os, isHidden: true },
        cf_user_email: { defaultValue: user?.email || "", isHidden: true },
    };
    window?.ZohoDeskAsap?.set("ticket.form.prefillValues", { [formKey]: prefillData });
}

export async function initiateZohoDesk() {
    if (!isZohoDeskAvailable()) return;
    await prefillZohoDeskForm();
}

export function updateZohoDeskPageData() {
    if (!isZohoDeskAvailable()) return;
    const formKey = getFormKey();
    if (!formKey) return;
    const route = window.location.href;
    window.ZohoDeskAsap?.set("ticket.form.prefillValues", {
        [formKey]: { cf_page: { defaultValue: route, isHidden: true } },
    });
}

export function updateZohoDeskUserData() {
    if (!isZohoDeskAvailable()) return;
    const formKey = getFormKey();
    if (!formKey) return;
    const user = getTokenValue();
    window.ZohoDeskAsap?.set("ticket.form.prefillValues", {
        [formKey]: {
            cf_user_id: { defaultValue: user ? user.id : "", isHidden: true },
            email: { defaultValue: user ? user.email : "" },
        },
    });
}

export function resetWidget() {
    if (!isZohoDeskAvailable()) return;
    const formKey = getFormKey();
    if (!formKey) return;

    const prefillData = {
        cf_user_id: { defaultValue: "", isHidden: true },
        cf_single_line_1: { defaultValue: "", isHidden: true },
        cf_page: { defaultValue: "", isHidden: true },
        cf_url: { defaultValue: "", isHidden: true },
        cf_user_email: { defaultValue: "", isHidden: true },
    };
    window.ZohoDeskAsap?.set("ticket.form.prefillValues", { [formKey]: prefillData });
}

function invokeWidget(action: string, ...args: any) {
    if (!isZohoDeskAvailable()) return;

    window.ZohoDeskAsapReady?.(function () {
        window.ZohoDeskAsap?.invoke(action, ...args);
    });
}

export function openWidget() {
    invokeWidget("open");
}

export function closeWidget() {
    invokeWidget("close");
}

export function showWidget() {
    invokeWidget("show", "app.launcher");
}

export function hideWidget() {
    invokeWidget("hide", "app.launcher");
}
